export default function ActionButtons({ editMode, setEditMode }) {
  return (
    <div className="action-section">
      <button className="btn-action" onClick={() => setEditMode(!editMode)}>
        <i className="fas fa-edit" /> {editMode ? "Close Edit" : "Edit"}
      </button>

      {/* <button className="btn-action">
        <i className="fas fa-trash-alt" /> Delete
      </button> */}
    </div>
  );
}
